import '../index.css';
import ResultCard from './ResultCard';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';


function Results() {

    return (
        <div className='results'>
            <h1 className='resultsHeader shadow' >Results</h1>
            <Container className='mt-5 mb-5'>
                <Row className='position-relative' style={{justifyContent:"center"}}>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/ashtonbefore.webp"} after={"img/ashtonafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/Madisonbefore.jpg"} after={"img/Madisonafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/gagebefore.webp"} after={"img/gageafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/Jaybefore.webp"} after={"img/Jayafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/jeremybefore.webp"} after={"img/Jeremyafter.webp"}/>
                    </Col >
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/Joeybefore.webp"} after={"img/Joeyafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/Zoeybefore2.webp"} after={"img/Zoeyafter2.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/lamondbefore.jpg"} after={"img/lamondafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/lynnbefore.webp"} after={"img/lynnafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/mitchbefore.webp"} after={"img/mitchafter.webp"}/>
                    </Col>
                    <Col xs={10} sm={6} md={4} lg={3}>
                        <ResultCard before={"img/Natebefore.webp"} after={"img/Nateafter.webp"}/>
                    </Col>  
                </Row>


            </Container>
        </div>
    );
}

export default Results;